import { CompanySearchFilters, CompanySearchRequest } from '../../../../generated/model/models';
import { icons } from '../../Companies/Filter/FilterLibrary/FilterIcon';

export enum FilterInputType {
  'DatePickerFilter' = 1, // datePicker
  'DateRangeFilter' = 2, // range datepciker
  'YearRangeFilter' = 3, // range year picker
  'WildcardTagsFilter' = 4, // chips input
  'WildcardTagsWithExclusionTagsFilter' = 5, // chips input with exclusion
  'ExactTagsFilter' = 6, // autocomplete
  'ExactTagsWithExclusionTagsFilter' = 7, // autocomplete with exclusion
  'SwitchShareholderFilter' = 8,
  'SwitchWithNumberRangeFilter' = 9,
  'TextFilter' = 10,
  'NumberRangeWithYearsFilter' = 11,
  'ValuesWithYearPeriodAndYearRangeFilter' = 12,
  'TreeWithExclusionFilter' = 13,
  'SwitchShareholdingFilter' = 14,
  'YearRangeWithOpenEndsFilter' = 15,
  'YearRangeWithPeriodCriteriaFilter' = 16,
  'StatusTagsExclusionFilterInput' = 17,
  'ContactInformationFilter' = 18,
  'CountryTagsExclusionFilterInput' = 19,
  'SingleTagFilter' = 20,
  'CurrencyFilter' = 21,
  'CompanyActivityFilter' = 22, // used for combined company activity filter
}

export type FilterAccordionInterface = string;

export type AppliedFilterInterface = string;

export interface FlattenedLibraryFilters {
  [key: string]: LibraryFilterItem;
}

export interface LibraryFilterItem {
  labelKey: string;
  type?: FilterInputType;
  children?: LibraryFilterItem[];
  options?: OptionsProps;
  defaultValue?: any;
  parent?: string;
  withUnknownSwitch?: boolean;
  unknownSwitchEnabled?: boolean;
  isPercentage?: boolean;
  icon?: keyof typeof icons;
  disabled?: boolean;
  mandatory?: boolean;
}

export interface OptionsProps {
  [key: string]: any;
  // criteriaOptions?: CriteriaOptionsProps[];
  // classifier?: ClassifiersTypes;
  // defaultCriteria?: CriteriaOptionsProps;
  // labelFormatter?: TagsFilterLabelFormatters;
}

export interface CriteriaOptionsProps {
  value: string;
  label: string;
}

export enum FinancialDataContextActionTypes {
  ToggleActiveFilter = 'filters/TOGGLE_ACTIVE_FILTER',
  Set = 'filters/SET_FILTER_INITIAL_STATE',
  Add = 'filters/ADD_TO_APPLIED_FILTERS',
  Remove = 'filters/REMOVE_FROM_APPLIED_FILTERS',
  ClearAppliedFilters = 'filters/CLEAR_APPLIED_FILTERS',
  ToggleLibraryFilter = 'filters/TOGGLE_LIBRARY_FILTER',
  UpdateFilterValues = 'filters/UPDATE_FILTER_VALUES',
  AddIncludeKeywordsFilterValues = 'filters/ADD_INCLUDE_KEYWORDS_FILTER_VALUES',
  AddExcludeKeywordsFilterValues = 'filters/ADD_EXCLUDE_KEYWORDS_FILTER_VALUES',
  UpdateHistorySearchValue = 'filters/UPDATE_HISTORY_SEARCH_VALUE',
  ToggleAppliedFilter = 'filters/TOGGLE_APPLIED_FILTER',
  SetRequestFilterValues = 'filters/SET_REQUEST_FILTER_VALUES',
  SetSaveFilterButtonState = 'filters/SET_SAVE_FILTER_BUTTON_STATE',
  SetPredefinedFilters = 'filters/SET_PREDEFINED_FILTERS',
  SetPredefinedFirstRender = 'filters/SET_PREDEFINED_FIRST_RENDER',
  SetSortModel = 'filters/SET_SORT_MODEL',
  ResetSortModel = 'filters/RESET_SORT_MODEL',
}

export type FinancialDataContextActions =
  | { type: FinancialDataContextActionTypes.ToggleActiveFilter; payload: string }
  | { type: FinancialDataContextActionTypes.Set; payload: CompanySearchRequest }
  | { type: FinancialDataContextActionTypes.Add; payload: AppliedFilterInterface }
  | { type: FinancialDataContextActionTypes.Remove; payload: AppliedFilterInterface }
  | { type: FinancialDataContextActionTypes.ClearAppliedFilters; payload: AppliedFilterInterface[] }
  | {
      type: FinancialDataContextActionTypes.ToggleLibraryFilter;
      payload: FilterAccordionInterface;
    }
  | { type: FinancialDataContextActionTypes.UpdateFilterValues; payload: CompanySearchFilters }
  | { type: FinancialDataContextActionTypes.AddIncludeKeywordsFilterValues; payload: string }
  | { type: FinancialDataContextActionTypes.AddExcludeKeywordsFilterValues; payload: string }
  | { type: FinancialDataContextActionTypes.UpdateHistorySearchValue; payload: boolean }
  | { type: FinancialDataContextActionTypes.ToggleAppliedFilter; payload: string }
  | { type: FinancialDataContextActionTypes.SetRequestFilterValues; payload: CompanySearchFilters }
  | { type: FinancialDataContextActionTypes.SetSaveFilterButtonState; payload: boolean }
  | { type: FinancialDataContextActionTypes.SetPredefinedFilters; payload: any[] }
  | { type: FinancialDataContextActionTypes.SetPredefinedFirstRender; payload: boolean }
  | { type: FinancialDataContextActionTypes.SetSortModel; payload: AgGridSortModel }
  | { type: FinancialDataContextActionTypes.ResetSortModel };

export type FinancialDataContextProps = {
  data: CompanySearchFilters;
  activeFiltter: string;
  requestFiltersData: CompanySearchFilters;
  historySearch: boolean;
  libraryFilters: LibraryFilterItem[];
  flattenedLibraryFilters: FlattenedLibraryFilters;
  expandedLibraryFilters: string[];
  appliedFilters: AppliedFilterInterface[];
  expandedAppliedFilter: string;
  version: string;
  saveFilterButtonState: boolean;
  predefinedFilters: any[];
  predefinedFirstRender: boolean;
  isRefinement: boolean;
  sortModel?: AgGridSortModel;
};

export type RequestParams = {
  page?: number;
  size?: number;
  sort?: string[];
  filter?: string[];
};

export type FilterProviderProps = {
  children: React.ReactNode;
  storageKey: string;
  version: string;
};

export type AgGridSortModel = {
  colId: string | undefined;
  sort: string | null | undefined;
}[];
